import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ironija",
  "description": "",
  "published": "2006-11-02T00:00:00.000Z",
  "redirect_from": ["/blog/ironija/swizec/371"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Danes sem se uspel vkrcati na cudovito potovanje po oddaljenih dezelah in daljnoseznih obalah morij domisljije, ampak zakaj si cel dan napisal le ubogih 300 besed, se boste vprasali. Kot je seveda standard, nadlezno pravilo nihce-ne-ve-cesa, ni bilo casa napisati vseh teh cudovitih besed. Medtem, ko sem vceraj prezdel ure in ure za racunalnikom in samo cakal, da privre kaka beseda na dan, sem danes bil odsoten in samo cakal, da bom koncno lahko spisal vse kar komaj caka da se bo izlilo in prelilo. Z besedo, neumnost.`}</p>
    <p>{`Se nekaj malega o trebuchetu, sedaj vsebuje 1.6 kilsko proti utez in se ob vsaki uporabi skoraj podre, domet pa je tako velik, da ga na zalost v tem stanovanju ne morem testirati; zalostno, preprosto zalostno.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      